import Card from "components/card";
import Loader from "components/loader";
import { getInstituciones } from "services/Reports";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";

const TOP_N = 5;

const TopInstitutionsWidget = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [instituciones, setInstituciones] = useState([]);

  const fetchTopInstituciones = async () => {
    setIsLoading(true);
    const data = await getInstituciones();
    const rows = Array.isArray(data?.[0]) ? data[0] : [];

    const top = [...rows]
      .sort((a, b) => Number(b?.publicaciones_count || 0) - Number(a?.publicaciones_count || 0))
      .slice(0, TOP_N);

    setInstituciones(top);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTopInstituciones();
  }, []);

  return (
    <Card extra="w-full h-full px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Instituciones más activas
        </div>
        <Link
          to={routesNames.INSTITUCIONES}
          className="text-sm hover:cursor-pointer bg-lightPrimary p-2 text-navy-700 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10 linear justify-center rounded-lg font-semibold transition duration-200"
        >
          Ver todas
        </Link>
      </div>

      <div className="mt-4">
        {isLoading ? (
          <Loader />
        ) : instituciones.length === 0 ? (
          <p className="text-sm text-gray-600">No hay datos disponibles</p>
        ) : (
          <ul className="flex flex-col gap-3">
            {instituciones.map((institucion) => (
              <li key={institucion.user_id} className="flex items-center justify-between">
                <Link
                  to={`${routesNames.USER}/${institucion.user_id}`}
                  className="text-sm font-semibold text-blue-800 dark:text-white"
                >
                  {institucion.nombre}
                </Link>
                <span className="text-sm font-bold text-navy-700 dark:text-white">
                  {institucion.publicaciones_count} publicaciones
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
};

export default TopInstitutionsWidget;
